import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Icon from '../../icon'
import { ensureAbsoluteUrl } from '../../../utils/url'
import { isCharityStripeVerified } from '../../../lib/stripeConnect'
import CharityVerificationBadge from './CharityVerificationBadge'
import styles from './CharityProfileLeftSidebar.module.scss'

export default function CharityProfileLeftSidebar({
  name,
  ein,
  alsoKnownAs,
  location,
  mission,
  websiteUrl,
  stripeStatus,
}) {
  const { t } = useTranslation()

  const displayWebsite = ensureAbsoluteUrl(websiteUrl)
  const isVerified = isCharityStripeVerified(stripeStatus)

  return (
    <div className={styles.sidebar}>
      <section className={styles.section}>
        <div className={styles.nameRow}>
          {name != null && <h2 className={styles.name}>{name}</h2>}
          <Icon name="hands-heart" className={styles.nameIcon} aria-hidden />
        </div>

        {isVerified ? (
          <div className={styles.badgeRow}>
            <CharityVerificationBadge stripeStatus={stripeStatus} />
          </div>
        ) : null}

        <hr className={styles.divider} />

        {ein ? (
          <>
            <div className={styles.labelRow}>
              <span className={styles.label}>
                {t('charities.profile.ein', 'EIN')}
              </span>
            </div>
            <p className={styles.value}>{ein}</p>
          </>
        ) : null}

        {alsoKnownAs ? (
          <>
            <div className={styles.labelRow}>
              <span className={styles.label}>
                {t('charities.profile.alsoKnownAs', 'Also Known As')}
              </span>
            </div>
            <p className={styles.value}>{alsoKnownAs}</p>
          </>
        ) : null}

        {location ? (
          <>
            <div className={styles.labelRow}>
              <span className={styles.label}>
                {t('charities.profile.location', 'Location')}
              </span>
            </div>
            <p className={styles.value}>{location}</p>
          </>
        ) : null}

        {mission ? <p className={styles.bio}>{mission}</p> : null}

        {displayWebsite ? (
          <p className={styles.websiteRow}>
            <a
              href={displayWebsite}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.websiteLink}
            >
              {displayWebsite.replace(/^https?:\/\//i, '')}
            </a>
          </p>
        ) : null}
      </section>
    </div>
  )
}

CharityProfileLeftSidebar.propTypes = {
  name: PropTypes.string,
  ein: PropTypes.string,
  alsoKnownAs: PropTypes.string,
  location: PropTypes.string,
  mission: PropTypes.string,
  websiteUrl: PropTypes.string,
  stripeStatus: PropTypes.object,
}
